webpackJsonp([15],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENV */
/* unused harmony export server */
/* unused harmony export host */
/* unused harmony export passportHost */
var serverConfigs = __webpack_require__(8);
var ENV = "prod_na";
var server = serverConfigs[ENV];

var host = server.host;
var passportHost = server.passportHost;

/* harmony default export */ __webpack_exports__["a"] = ({
  host: server.host,
  passportHost: server.passportHost,
  env: ENV,
  APP_KEY: 'CZUR_PASSPORT_WEB',
  CHANNEL: 'ALL',
  DEFAULT_PAGE: 'basic.html',
  HTTP_HEADER_KEY: {
    APP_KEY: 'App-Key',
    UDID: 'udid',
    CHANNEL: 'Channel',
    TOKEN: 'T-ID',
    USERID: 'U-ID'
  },
  COOKIE_KEY: {
    U_ID: 'U-ID',
    TOKEN: 'T-ID',
    USER_NAME: 'user',
    LANG: 'lang'
  },
  CALL_BACK: '',
  R_CODE: {
    SUCCESS: 1000,
    INTERNAL_ERROR: 1001,
    INVALID_TOKEN: 1002,
    BAD_ACCESS: 1003,
    PWD_ERROR: 1004,
    USER_INACTIVE: 1005,
    CHANNEL_UNSUPPORT: 1006,
    INVALID_MOBILE: 1007,
    INVALID_EMAIL: 1008,
    SMS_MANY_REQUEST: 1009,
    SMS_SEND_10S: 1010,
    USER_EXIST: 1011,
    MAIL_MANY_REQUEST: 1012,
    MAIL_SEND_10S: 1013,
    INVALID_CODE: 1014,
    IMG_PRO_ERROR: 1015,
    IMG_PRO_ING: 1016,
    INVALID_USER_NAME: 1017,
    USER_NO_EXIST: 1018,
    TIME_OUT: 1019,
    IMG_NOT_FOUND: 1020,
    DEVICE_OCCUPIED: 1021,
    USER_USING_DEVICE: 1022,
    MANY_REQUEST_CODE: 1023,
    PWD_OLD_SAME: 1030,
    PWD_OLD_ERROR: 1031,
    NO_MOBILE_BIND: 1032,
    CODE_ERROR: 1033,
    MOBILE_USED_OTHERS: 1034,
    EMAIL_USED_OTHERS: 1035
  },
  getChannel: function getChannel() {
    var channel = this.getReqParam('Channel');
    if (!channel) {
      channel = this.CHANNEL;
    }
    return channel;
  },
  cookieSet: function cookieSet(key, value) {
    var Days = 30;
    var date = new Date();
    date.setTime(date.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + escape(value) + '; path=/;expires = ' + date.toGMTString();
  },
  cookieGet: function cookieGet(key) {
    var result;
    var mycookie = document.cookie;
    var start2 = mycookie.indexOf(key + '=');
    if (start2 > -1) {
      var start = mycookie.indexOf('=', start2) + 1;
      var end = mycookie.indexOf(';', start);
      if (end === -1) {
        end = mycookie.length;
      }
      result = unescape(mycookie.substring(start, end));
    }
    return result;
  },
  getReqParam: function getReqParam(param) {
    var url = window.location.search;
    var theRequest = {};
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1);
      var strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
      }
    }
    return theRequest[param];
  },
  appendParam: function appendParam(url, param, value) {
    var archor = '';
    if (url.indexOf('#') > 0) {
      var strs = url.split('#');
      url = strs[0];
      archor = strs[1];
    }
    if (url.indexOf('?') >= 0) {
      url = url + '&';
    } else {
      url = url + '?';
    }
    url = url + param + '=' + encodeURIComponent(value);
    if (archor !== '') {
      url = url + '#' + archor;
    }
    return url;
  },
  getLocalStore: function getLocalStore(key) {
    return localStorage.getItem(key);
  },
  setLocalStore: function setLocalStore(key, value) {
    localStorage.setItem(key, value);
  },
  lang: function lang() {
    var requestLang = this.getReqParam('lang');
    var currentLang = this.cookieGet('lang');
    if (requestLang !== undefined && requestLang !== '' && requestLang !== currentLang) {
      currentLang = requestLang;
      this.cookieSet('lang', currentLang);
    }
    if (!currentLang) {
      currentLang = navigator.language;
      if (!currentLang) {
        currentLang = navigator.browserLanguage;
      }
    }
    if (currentLang !== 'en' && currentLang !== 'zh-CN' && currentLang !== 'zh-TW' && currentLang !== 'ru_RU') {
      currentLang = 'en';
    }
    return currentLang;
  },
  local4Service: function local4Service() {
    var lang = this.lang();
    var local = lang.replace('-', '_');
    return local;
  },
  urlRemoveParam: function urlRemoveParam(param) {
    var url = window.location.href;
    if (window.location.search.indexOf(param[0]) >= 0) {
      var hosturl = url.replace(window.location.search, '').replace(window.location.hash, '');
      var params = window.location.search.substr(1);
      var strs = params.split('&');
      for (var m = 0; m < param.length; m++) {
        var one = param[m];
        for (var i = 0; i < strs.length; i++) {
          if (strs[i].indexOf(one) >= 0) {
            strs.splice(i, 1);
            break;
          }
        }
      }
      if (strs.length > 0) {
        var search = strs.join('&');
        hosturl = hosturl + '?' + search;
      }
      url = hosturl + window.location.hash;
    }
    return url;
  }
});

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(473)
__webpack_require__(474)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(441),
  /* scopeId */
  "data-v-b4c1649a",
  /* cssModules */
  null
)
Component.options.__file = "/mnt/opt/jenkins/workspace/czur_passport_pc_Html_prod_na/src/module/sm_vip_privacy_en/sm_vip_privacy_en.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] sm_vip_privacy_en.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b4c1649a", Component.options)
  } else {
    hotAPI.reload("data-v-b4c1649a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sm_vip_privacy_en_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sm_vip_privacy_en_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sm_vip_privacy_en_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_common_script_getRem_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_common_stylus_index_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__ = __webpack_require__(0);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.interceptors.push(function (request, next) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.APP_KEY] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].APP_KEY;

  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.headers.common[__WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].HTTP_HEADER_KEY.CHANNEL] = __WEBPACK_IMPORTED_MODULE_5_common_script_config_js__["a" /* default */].getChannel();

  next(function (response) {
    return response;
  });
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__sm_vip_privacy_en_vue___default.a);
  }
}).$mount('#smVipPrivacy');

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'smVipPrivacy',
  data: function data() {
    return {
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isShow = true;
    }, 100);
  }
});

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\n#smVipPrivacy {\n  margin: 0.25rem;\n  font-size: 0.14rem;\n  line-height: 0.24rem;\n  text-align: justify;\n  height: auto;\n}\n#smVipPrivacy div {\n  margin: 0.1rem 0;\n}\n#smVipPrivacy div.title {\n  text-indent: 0;\n  font-weight: bold;\n  font-size: 0.16rem;\n}\n#smVipPrivacy div a {\n  color: #000;\n}\n#smVipPrivacy div a:hover {\n  color: #0982cb;\n}\n", ""]);

// exports


/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)();
// imports


// module
exports.push([module.i, "\nbody[data-v-b4c1649a], p[data-v-b4c1649a], div[data-v-b4c1649a], span[data-v-b4c1649a], article[data-v-b4c1649a], section[data-v-b4c1649a] {\n  text-align: left !important;\n  text-justify: none !important;\n  word-spacing: normal !important;\n  letter-spacing: normal !important;\n}\n", ""]);

// exports


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

var docEl = document.documentElement;
var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
var remSize = 100;
var recalc = function recalc() {
  var clientWidth = docEl.clientWidth;
  if (!clientWidth) {
    return;
  }
  if (clientWidth <= 720) {
    docEl.style.fontSize = remSize * (clientWidth / 500) + 'px';
  } else {
    docEl.style.fontSize = remSize + 'px';
  }
};

if (document.addEventListener) {
  window.addEventListener(resizeEvt, recalc, false);
  document.addEventListener('DOMContentLoaded', recalc, false);
}

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "smVipPrivacy"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('div', [_vm._v("Important Notice")]), _vm._v(" "), _c('div', [_vm._v("Welcome to use the Minimal Scan VIP (hereinafter referred to as \"VIP\") Service. To protect your rights and interests, please carefully read all contents of this service agreement (hereinafter referred to as \"this Agreement\") before using the VIP Service.")]), _vm._v(" "), _c('div', [_vm._v("You are not entitled to use the VIP Service unless you have read and accepted all terms of this Agreement. Your purchase or use of the VIP Service shall be deemed as your acknowledgment and acceptance of the terms of this Agreement.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Article 1 Acceptance and Revision of the Service Agreement")]), _vm._v(" "), _c('div', [_vm._v("1.1 This Agreement includes the main text of the agreement and all rules that CZUR Technology has published or may publish/update in the future. All such rules are an integral part of this Agreement and shall have the same legal effect as the main text. In case of any conflict between the main text and the aforesaid rules, the main text of this Agreement shall prevail. Unless otherwise explicitly stated, your use of the VIP Service shall be governed by this Agreement.")]), _vm._v(" "), _c('div', [_vm._v("1.2 If this Agreement and related service terms need to be revised due to business development, CZUR Technology will publish the revised terms on the CZUR Cloud Platform. You may visit the platform to review the latest version of the agreement terms. If you do not accept the revised terms after CZUR Technology modifies them, you may choose to terminate the use of the VIP Service. Your continued use of the Service shall be deemed as your acceptance of the revised terms.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Article 2 Definitions")]), _vm._v(" "), _c('div', [_vm._v("2.1 VIP: Refers to the value-added service provided by CZUR Technology. After becoming a VIP, you may enjoy certain preferential privileges or participate in activities under this Agreement. The specific service content shall be subject to what is provided by CZUR Technology. The ownership, operation rights, and the right to formulate VIP systems and activities shall belong to CZUR Technology, which has the right to interpret within the scope of laws and regulations.")]), _vm._v(" "), _c('div', [_vm._v("2.2 \"User\" or \"You\": Refers to an individual or a single entity that enjoys the VIP Service provided by CZUR Technology.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Article 3 Procedures for Activating VIP")]), _vm._v(" "), _c('div', [_vm._v("3.1 To use the VIP Service, you need to first log in to your Minimal Scan account or register and log in to a Minimal Scan account. On the basis of successfully logging in to the Minimal Scan account, you may apply to activate the VIP Service. If you use other third-party accounts to log in to Minimal Scan, you shall ensure the stability, authenticity, and availability of the third-party account. If you are unable to log in to Minimal Scan due to issues with the third-party account (such as account suspension), you shall contact the company providing the third-party account. The Minimal Scan account you use to log in when using the VIP Service is the sole basis for CZUR Technology to confirm your identity.")]), _vm._v(" "), _c('div', [_vm._v("3.2 You may activate the VIP Service by completing payment through a payment method recognized by CZUR Technology on the activation service interface. When activating the service, you shall carefully verify the account name, type of service to be activated, and duration, etc. CZUR Technology shall not refund the fees collected if the account is incorrectly charged, or the service type or duration is incorrectly activated due to your personal reasons.")]), _vm._v(" "), _c('div', [_vm._v("3.3 CZUR Technology may adjust the content of VIP privileges from time to time based on business development. You shall promptly pay attention to and understand the changes in VIP privileges and policies, and agree to and accept the adjustments made by CZUR Technology. Before CZUR Technology adjusts the VIP privileges, you may have already enjoyed or been enjoying certain VIP service contents or benefits. You understand and accept that such adjustments to the privileges may affect the benefits you have enjoyed or are enjoying, and agree to use the service in accordance with the adjusted privilege content without requiring CZUR Technology to assume any liability.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Article 4 Provisions on VIP Eligibility")]), _vm._v(" "), _c('div', [_vm._v("4.1 The VIP Service is only for the use of the applying account and cannot be transferred between different Minimal Scan accounts.")]), _vm._v(" "), _c('div', [_vm._v("4.2 If you proactively cancel or terminate your VIP eligibility during the validity period of the activated VIP, you will not receive a refund of the VIP fees.")]), _vm._v(" "), _c('div', [_vm._v("4.3 After the cancellation/termination of VIP eligibility, you will no longer be able to participate in activities organized by Minimal Scan or enjoy any privilege services or value-added services provided by Minimal Scan, i.e., you will no longer enjoy the VIP Service.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Article 5 Liability Declaration")]), _vm._v(" "), _c('div', [_vm._v("5.1 If you exercise the rights under this Agreement to purchase/accept goods or services provided by third-party merchants other than CZUR Technology, any disputes arising therefrom shall be claimed against the third-party merchant selling/providing such goods or services, which shall be irrelevant to CZUR Technology.")]), _vm._v(" "), _c('div', [_vm._v("5.2 You shall bear full legal liability for all acts committed by yourself and the guests you invite during their participation in activities organized by Minimal Scan or their use of preferential and value-added services provided by Minimal Scan.")]), _vm._v(" "), _c('div', [_vm._v("5.3 CZUR Technology shall not be liable for any losses caused by the acts or omissions of third parties or force majeure, including but not limited to payment services, network access services, telecommunication line failures of telecommunication departments, communication technical issues, network or computer failures, system instability, and infringement acts of any third parties.")]), _vm._v(" "), _c('div', [_vm._v("5.4 You understand and agree that during the use of the VIP Service, you may encounter risk factors such as force majeure, which may cause service interruption. In such cases, CZUR Technology undertakes to cooperate with relevant units to repair the service as soon as possible, but shall not be liable for any losses incurred by you and shall not refund the VIP fees.")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Article 6 Other Agreements")]), _vm._v(" "), _c('div', [_vm._v("6.1 Service Suspension, Interruption, and Termination: CZUR Technology may choose to suspend, interrupt, or terminate the VIP Service based on its own business decisions, government actions, force majeure, or other reasons. In such cases, CZUR Technology will notify you through announcements, but shall not be liable for any losses incurred by you and shall not refund the VIP fees.")]), _vm._v(" "), _c('div', [_vm._v("6.2 CZUR Technology's failure to exercise, delay in exercising, or incomplete exercise of any rights under this Agreement or under the law shall not be deemed as a waiver of such rights, nor shall it affect CZUR Technology's right to exercise such rights in the future.")]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("6.3 3. If you have any questions regarding the content of these terms, please send an email to our customer service mailbox: "), _c('a', {
    attrs: {
      "href": "mailto:support@czur.com"
    }
  }, [_vm._v("support@czur.com")]), _vm._v(".")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b4c1649a", module.exports)
  }
}

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(373);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("53e1d803", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b4c1649a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./sm_vip_privacy_en.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b4c1649a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./sm_vip_privacy_en.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(374);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("e2d4b60a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b4c1649a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./sm_vip_privacy_en.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-b4c1649a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./sm_vip_privacy_en.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  test: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  test_na: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  prod: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  },
  prod_na: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  }
};

/***/ })

},[271]);


// WEBPACK FOOTER //
// static/js/module/sm_vip_privacy_en.b19a6990c2a08b9f8332.js